import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsElasticsearchComponent } from './simple-icons-elasticsearch.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsElasticsearchComponent ],
    exports:      [ SimpleIconsElasticsearchComponent ],
    bootstrap:    []
})
export class SimpleIconsElasticsearchModule {}
